var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 22.9166H20.8332",
    stroke: "#122733",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4666 3.81559L15.239 3.04319C16.5187 1.76344 18.5936 1.76344 19.8734 3.04319C21.1531 4.32294 21.1531 6.39783 19.8734 7.67759L19.101 8.44999M14.4666 3.81559C14.4666 3.81559 14.5631 5.45694 16.0114 6.90519C17.4596 8.35344 19.101 8.44999 19.101 8.44999M14.4666 3.81559L7.36552 10.9166C6.88456 11.3976 6.64407 11.6381 6.43725 11.9032C6.19328 12.216 5.98412 12.5545 5.81346 12.9126C5.66878 13.2161 5.56123 13.5388 5.34614 14.1841L4.43468 16.9184M19.101 8.44999L11.9999 15.551C11.519 16.032 11.2785 16.2725 11.0133 16.4793C10.7005 16.7233 10.3621 16.9324 10.004 17.1031C9.70042 17.2478 9.37777 17.3553 8.73249 17.5704L5.9981 18.4819M5.9981 18.4819L5.32971 18.7047C5.01215 18.8105 4.66205 18.7279 4.42536 18.4912C4.18867 18.2545 4.10603 17.9044 4.21188 17.5868L4.43468 16.9184M5.9981 18.4819L4.43468 16.9184",
    stroke: "#122733",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIcon1);
export default __webpack_public_path__ + "static/media/step-icon1.203d37d7ef8f385812c0d8ad3c36603b.svg";
export { ForwardRef as ReactComponent };